export class DispenserCategories {
  values?: DispenserCategory[]
}

export class DispenserCategory {
  count?: number
  name?: string
  query?: Query
  selected?: boolean
}
export class Query {
  url?: string
  query?: QueryValue
}

export class QueryValue {
  value?: string
}

export class DispenserTypes {
  FOLTypes?: string[]
  servicesTypes?: string[]
}

export class DispenserAgreementsSubmitPayload {
  agreementTypes?: AgreementTypes
  endCustomerInformation?: EndCustomerInformation
  requesterInformation?: RequesterInformation
  termInformation?: TermInformation
}

export class DispenserAgreementUpdatePayload {
  agreementTypes: {
    agreementType: string
    agreementNumber: string
    products: ProductsEntry[]
  }
}

export class AgreementTypes {
  agreementType?: string
  products?: ProductsEntry[]
}

export class ProductsEntry {
  productCode?: string
  quantity?: number
  newProduct?: boolean
}

export class EndCustomerInformation {
  abn?: string
  addressLine1?: string
  addressLine2?: string
  businessName?: string
  contactName?: string
  email?: string
  installReason?: string
  installer?: string
  phoneNumber?: string
  postalCode?: string
  state?: string
}

export class RequesterInformation {
  abn?: string
  addressLine1?: string
  addressLine2?: string
  asaleoCareRepresentative?: string
  distributionCompany?: string
  email?: string
  phoneNumber?: string
  postalCode?: string
  requesterName?: string
  state?: string
  uid?: string
}

export class TermInformation {
  yesNo?: boolean
  comments?: string
}

// Update Dispenser Agreement
export class AgreementTypeProducts {
  folType: string
  categoryName: string
  products: Product[] | ProductsFromEntries[]
}

export class Product {
  code: string
  colour: string
  name: string
  system: string
  systemType: string
}

export class ProductsFromEntries {
  code: string
  colour: string
  name: string
  system: string
  systemType: string
  quantity: number
  newProduct?: boolean
}

export class AgreementDetailEntry {
  entryNumber: number
  product: {
    code: string
    colour: string
    name: string
  }
  quantity: number
  shipmentType: string
}

export class Entry {
  code: string
  colour: string
  quantity: number
  name: string
}
